import { Flex, Box} from 'components/ui';
import bassIcon from 'img/bass.svg';
import synthIcon from 'img/synth.svg';
import drumIcon from 'img/drum.svg';
import raiserIcon from 'img/raiser.svg';
import fxIcon from 'img/fx.svg';

const LAYER_ICONS = {
  Lead: synthIcon,
  Backing: bassIcon,
  Drums: drumIcon,
  Ambience: raiserIcon,
  FX: fxIcon,
};

const LayerIcon = ({ name }) => {
  return (
    <Flex width="calc(14.28% - 8px)" height="80px" px={1} justifyBetween>
      <Flex width="60px" height="80px" flexDirection="column" alignCenter justifyCenter>
        <img src={ LAYER_ICONS[name] || synthIcon } alt={name} width="24px" />
        <Box mt={1} fontSize="10px">{ name }</Box>
      </Flex>
      <Box fontSize="18px">
        <Flex height="40px" alignCenter>A</Flex>
        <Flex height="40px" alignCenter>B</Flex>
      </Box>
    </Flex>
  )
}

export default LayerIcon;
